(function ($) {
  'use strict';

  const ITEM_ID = '10107783';
  const SHOP_BID = '203706';
  const VARIANT_ID = '555a00045';

  const BASE_IMG = 'https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/mirai/float_tv/';
  const BG_IMG = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/';
  const EXISTING_URL = 'https://item.rakuten.co.jp/arne/';

  const LIMITS = {
    haba: { min: 60, max: 180, label: '幅' },
    depth: { min: 20, max: 30, label: '奥行' },
    height: { min: 30, max: 60, label: '高さ' }
  };

  const MATERIAL_TEXT = {
    wood: 'リーズナブル木目：<br>[材質]強化紙化粧合板、プリント化粧合板',
    aino: 'パステルカラーaino：<br>[材質]強化紙化粧合板',
    mela: 'ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)'
  };

  const COLOR_BAND = {
    A: ['wood', 'aino'],
    B: ['nail', 'bk', 'bp'],
    C: ['mb', 'gs', 'ww']
  };

  const ROW_BASE = { A: 0, B: 4, C: 8 };

  let priceTable = null;
  let existingList = null;
  let detachedPanelOption2 = null;
  let initialColorApplied = false;

  function onlyDigits(v) {
    return String(v == null ? '' : v).replace(/[^\d]/g, '');
  }

  function readInt(id) {
    const el = document.getElementById(id);
    if (!el) return { el: null, val: NaN, isEmpty: true };
    const cleaned = onlyDigits(el.value);
    if (el.value !== cleaned) el.value = cleaned;
    const isEmpty = cleaned === '';
    const val = isEmpty ? NaN : parseInt(cleaned, 10);
    return { el, val, isEmpty };
  }

  function ceil10(n) {
    return Math.ceil(n / 10) * 10;
  }

  function formatYen(n) {
    const s = String(n == null ? '' : n).replace(/[^\d]/g, '');
    if (!s) return '';
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '円';
  }

  function formatApprox(n) {
    if (!Number.isFinite(n)) return '';
    const rounded = Math.round(n * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 1e-9) return '約' + Math.round(rounded);
    return '約' + rounded.toFixed(1);
  }

  function normalizeColorToken() {
    const $checked = $('input[name="colortype1"]:checked');
    const dataType = String($checked.data('type') || '').toLowerCase();
    const id = String($checked.attr('id') || '').toLowerCase();
    const value = String($checked.val() || '');

    if (dataType === 'wood' || dataType === 'aino') return dataType;
    if (id.indexOf('mela_') === 0) return id.replace(/^mela_/, '');
    if (value) return value.toLowerCase();
    return '';
  }

  function existingColorKey() {
    const $checked = $('input[name="colortype1"]:checked');
    const dataType = String($checked.data('type') || '').toLowerCase();
    if (dataType === 'wood' || dataType === 'aino') return dataType;
    return String($checked.val() || '');
  }

  function getBandByColor() {
    const token = normalizeColorToken();
    if (COLOR_BAND.A.indexOf(token) !== -1) return 'A';
    if (COLOR_BAND.B.indexOf(token) !== -1) return 'B';
    if (COLOR_BAND.C.indexOf(token) !== -1) return 'C';
    return null;
  }

  function getSelectedColorName() {
    return $('input[name="colortype1"]:checked').val() || '';
  }

  function getSelectedColorId() {
    return $('input[name="colortype1"]:checked').attr('id') || '';
  }

  function getSelectedMaterialType() {
    return String($('input[name="colortype1"]:checked').data('type') || '').toLowerCase();
  }

  function getPanelCount() {
    const n = parseInt(String($('#panel').val() || '0'), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function getOpPanelCount() {
    const n = parseInt(onlyDigits($('.form_checkbox--num').val()), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function getTotalShelfCount() {
    return getPanelCount() + getOpPanelCount();
  }

  function getDowelLabel() {
    if (getOpPanelCount() > 0) return '有り';
    return getPanelCount() === 0 ? '無し' : '有り';
  }

  function getStoreSymbol(sum) {
    return sum >= 241 ? '☆' : '●';
  }

  function $sizeMsg() {
    return $('.form_size').closest('.form').find('> .msg').first();
  }

  function $orderMsg() {
    return $('.order-summary > .msg');
  }

  function setCheckoutUIEnabled(on) {
    const price = document.querySelector('.check_price');
    const cart = document.querySelector('.cart--btn');
    if (price) price.setAttribute('style', on ? '' : 'visibility: hidden');
    if (cart) {
      if (on) cart.removeAttribute('disabled');
      else cart.setAttribute('disabled', '');
    }
  }

  function resetOrderSummary() {
    $orderMsg().empty();
    $('.check_area li span').text('');
    $('.check_price').empty();
    setCheckoutUIEnabled(false);
    $('#units').val('');
  }

  function loadPriceOnce() {
    if (Array.isArray(priceTable)) return $.Deferred().resolve(priceTable).promise();
    return $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/float-tv_price.csv?v=1774845959" }).then(function (text) {
      priceTable = $.csv.toArrays(text).map(function (row) {
        return row.map(function (v) {
          return parseInt(String(v).replace(/[^\d]/g, ''), 10);
        });
      });
      return priceTable;
    }).catch(function () {
      priceTable = [];
      return priceTable;
    });
  }

  function loadExistingOnce() {
    if (Array.isArray(existingList)) return $.Deferred().resolve(existingList).promise();
    return $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/float-tv_existing.csv?v=1774845958", dataType: 'text' }).then(function (text) {
      existingList = $.csv.toArrays(text);
      return existingList;
    }).catch(function () {
      existingList = [];
      return existingList;
    });
  }

  function setBubbleBySelectedColor() {
    const type = getSelectedMaterialType();
    const text = MATERIAL_TEXT[type] || '選択してください';
    $('.material_bubble').html(text);
  }

  function syncDowelHole() {
    $('#dowel_hole').val(getDowelLabel());
  }

  function sanitizeExtraPanelInput() {
    const $num = $('.form_checkbox--num');
    const cleaned = onlyDigits($num.val()).slice(0, 1);
    if ($num.val() !== cleaned) $num.val(cleaned);
  }

  function updateExtraPanelFieldState() {
    const $check = $('#op_panel');
    const $num = $('.form_checkbox--num');
    if ($check.prop('checked')) {
      $num.prop('disabled', false);
      $num.css({
        opacity: '1',
        background: '#fff',
        border: '1px solid #ccc',
        width: '50%',
        height: '2.5em'
      });
    } else {
      $num.val('');
      $num.prop('disabled', true);
      $num.removeAttr('style');
    }
    sanitizeExtraPanelInput();
    syncDowelHole();
  }

  function updatePanelOptions() {
    const $panel = $('#panel');
    if (!$panel.length) return;

    if (!detachedPanelOption2) {
      const $opt2 = $panel.find('option[value="2"]');
      if ($opt2.length) detachedPanelOption2 = $opt2.clone();
    }

    const haba = readInt('haba').val;
    const has2 = $panel.find('option[value="2"]').length > 0;
    const allow2 = Number.isFinite(haba) && haba >= 91;

    if (allow2) {
      if (!has2 && detachedPanelOption2) $panel.append(detachedPanelOption2.clone());
    } else {
      if (String($panel.val()) === '2') $panel.val('0');
      $panel.find('option[value="2"]').remove();
    }

    syncDowelHole();
    updatePreviewImages();
  }

  function getPreviewFolderByWidth(width) {
    const w = Number(width);
    if (!Number.isFinite(w)) return '600';
    if (w <= 70) return '600';
    if (w <= 90) return '900';
    if (w <= 120) return '1200';
    if (w <= 150) return '1500';
    return '1800';
  }

  function resizeFormSizeImages() {
    const $wrap = $('.form_size--img');
    if (!$wrap.length) return;
    const width = $wrap.width();
    let maxH = 0;

    $wrap.find('img').each(function () {
      if (width) $(this).css('width', width + 'px');
      const h = $(this).height();
      if (h > maxH) maxH = h;
    });

    if (maxH > 0) $wrap.height(maxH);
  }

  function bindResizeAfterLoad() {
    $('.form_size--img img').off('load.floatTvResize').on('load.floatTvResize', function () {
      resizeFormSizeImages();
    });
  }

  function updatePreviewImages() {
    const colorId = getSelectedColorId() || 'wood_br';
    const materialType = getSelectedMaterialType() || 'wood';
    const panelVal = String($('#panel').val() || '0');
    const widthVal = readInt('haba').val;
    const folder = getPreviewFolderByWidth(widthVal);
    const bgSuffix = (materialType === 'mela') ? '22' : '20';

    const area1 = document.querySelector('.form_size--img img[name="area1"]');
    const area2 = document.querySelector('.form_size--img img[name="area2"]');
    const area3 = document.querySelector('.form_size--img img[name="area3"]');
    const area4 = document.querySelector('.form_size--img img[name="area4"]');

    if (area1) area1.src = BASE_IMG + folder + '/arrow.png';
    if (area2) area2.src = BASE_IMG + folder + '/close-' + colorId + '.png';
    if (area3) area3.src = BASE_IMG + folder + '/open_t' + panelVal + '-' + colorId + '.png';
    if (area4) area4.src = BG_IMG + 'background-panel' + bgSuffix + '.png';

    resizeFormSizeImages();
  }

  function calcInnerWidth(width, materialType) {
    if (!Number.isFinite(width)) return NaN;
    if (materialType === 'mela') {
      return width >= 91 ? (width - 8.8) / 2 : width - 4.4;
    }
    return width >= 91 ? (width - 8) / 2 : width - 4;
  }

  function calcInnerDepth(depth, materialType) {
    if (!Number.isFinite(depth)) return NaN;
    return materialType === 'mela' ? depth - 4.4 : depth - 4.2;
  }

  function calcInnerHeight(height, materialType) {
    if (!Number.isFinite(height)) return NaN;
    return materialType === 'mela' ? height - 6.5 : height - 6.1;
  }

  function updateInnerDisplayOne(key) {
    const materialType = getSelectedMaterialType() || 'wood';
    const rec = readInt(key);
    let value = NaN;
    let outId = '';
    let lim = null;

    if (key === 'haba') {
      value = calcInnerWidth(rec.val, materialType);
      outId = 'haba_id';
      lim = LIMITS.haba;
    } else if (key === 'depth') {
      value = calcInnerDepth(rec.val, materialType);
      outId = 'depth_id';
      lim = LIMITS.depth;
    } else if (key === 'height') {
      value = calcInnerHeight(rec.val, materialType);
      outId = 'height_id';
      lim = LIMITS.height;
    }

    if (!outId) return;

    if (rec.isEmpty || !Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      $('#' + outId).val('');
      return;
    }

    $('#' + outId).val(formatApprox(value));
  }

  function updateInnerDisplays() {
    updateInnerDisplayOne('haba');
    updateInnerDisplayOne('depth');
    updateInnerDisplayOne('height');
  }

  function removeSizeError(key) {
    $sizeMsg().find('.note-size-error[data-error-key="' + key + '"]').remove();
  }

  function setSizeError(key, text) {
    removeSizeError(key);
    if (!text) return;
    $sizeMsg().append($('<p class="note-size-error">').attr('data-error-key', key).text(text));
  }

  function validateSizeFieldForBlur(key) {
    const lim = LIMITS[key];
    if (!lim) return;
    const rec = readInt(key);
    if (rec.isEmpty) {
      removeSizeError(key);
      return;
    }
    if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      setSizeError(key, lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + (Number.isFinite(rec.val) ? rec.val : '') + 'cm）');
      return;
    }
    removeSizeError(key);
  }

  function buildJumpSizeErrors() {
    const errors = [];
    ['haba', 'depth', 'height'].forEach(function (key) {
      const lim = LIMITS[key];
      const rec = readInt(key);
      if (rec.isEmpty) {
        errors.push(lim.label + 'を入力してください');
      } else if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
        errors.push(lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + rec.val + 'cm）');
      }
    });
    return errors;
  }

  function findExistingCode(data) {
    if (!Array.isArray(existingList)) return null;
    for (let i = 0; i < existingList.length; i++) {
      const row = existingList[i] || [];
      const code = String(row[0] || '').trim();
      const w = parseInt(String(row[1] || '').replace(/[^\d]/g, ''), 10);
      const d = parseInt(String(row[2] || '').replace(/[^\d]/g, ''), 10);
      const h = parseInt(String(row[3] || '').replace(/[^\d]/g, ''), 10);
      const totalShelf = parseInt(String(row[5] || '').replace(/[^\d]/g, ''), 10);
      const color = String(row[6] || '').trim();

      if (!code) continue;
      if (
        w === data.haba &&
        d === data.depth &&
        h === data.height &&
        totalShelf === data.totalShelf &&
        color.toLowerCase() === String(data.color).toLowerCase()
      ) {
        return code;
      }
    }
    return null;
  }

  function setChoiceValues(data) {
    const choice1 = '幅：' + data.haba + 'cm/';
    const choice2 = '奥行：' + data.depth + 'cm/';
    const choice3 = '高さ：' + data.height + 'cm/';
    const choice4 = 'ダボ穴：' + data.dowel + '/';
    const choice5 = 'カラー：' + data.colorName + '/';
    const choice6 = '合計棚板枚数：' + data.totalShelf + '枚/';
    const choice7 = '店舗用記号：' + data.symbol + '/';
    const choice8 = '見積もり金額：' + data.price;

    $('#choice1').val(choice1);
    $('#choice2').val(choice2);
    $('#choice3').val(choice3);
    $('#choice4').val(choice4);
    $('#choice5').val(choice5);
    $('#choice6').val(choice6);
    $('#choice7').val(choice7);
    $('#choice8').val(choice8);
    $('#units').val(String(Math.round(data.price / 100)));
  }

  function buildEncodedChoice() {
    const lines = [
      $('#choice1').val(),
      $('#choice2').val(),
      $('#choice3').val(),
      $('#choice4').val(),
      $('#choice5').val(),
      $('#choice6').val(),
      $('#choice7').val(),
      $('#choice8').val()
    ].filter(function (v) {
      return String(v || '').length > 0;
    });

    const choice = lines.join('\r\n');
    const unicodeArray = Encoding.stringToCode(choice);
    const eucArray = Encoding.convert(unicodeArray, { to: 'EUCJP', from: 'UNICODE' });
    return Encoding.urlEncode(eucArray);
  }

  function submitToRakutenCart(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    const units = $('#units').val();
    if (!units || !$('#choice1').val() || !$('#choice8').val()) return false;

    const encodedChoice = buildEncodedChoice();
    const existingForm = document.querySelector('form[name="cart_form_ori"]');
    if (existingForm) existingForm.remove();

    const form = document.createElement('form');
    form.method = 'post';
    form.name = 'cart_form_ori';
    form.action = 'https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set';
    form.acceptCharset = 'EUC-JP';
    form.target = '_blank';

    [
      { name: 'shop_bid', value: SHOP_BID },
      { name: 'item_id', value: ITEM_ID },
      { name: 'variant_id', value: VARIANT_ID },
      { name: 'units', value: units },
      { name: 'choice', value: encodedChoice }
    ].forEach(function (d) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = d.name;
      input.value = d.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    return false;
  }

  window.jump = function jump() {
    const $msg = $orderMsg();
    $msg.empty();

    const sizeErrors = buildJumpSizeErrors();
    const colorName = getSelectedColorName();
    const materialType = getSelectedMaterialType();
    const band = getBandByColor();

    if (sizeErrors.length) {
      sizeErrors.forEach(function (t) {
        $msg.append($('<p class="note-submit-error">').text(t));
      });
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    if (!colorName || !materialType || !band) {
      $msg.append($('<p class="note-submit-error">').text('カラーを選択してください'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    if (!Array.isArray(priceTable) || !priceTable.length) {
      $msg.append($('<p class="note-submit-error">').text('価格表の読み込みに失敗しました'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    const haba = readInt('haba').val;
    const depth = readInt('depth').val;
    const height = readInt('height').val;
    const w10 = ceil10(haba);
    const h10 = ceil10(height);
    const col = Math.round((w10 - 60) / 10);
    const row = ROW_BASE[band] + Math.round((h10 - 30) / 10);
    const basePrice = priceTable[row] && priceTable[row][col];

    if (!Number.isFinite(basePrice)) {
      $msg.append($('<p class="note-submit-error">').text('価格が見つかりませんでした'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    const totalShelf = getTotalShelfCount();
    const dowel = getDowelLabel();
    const sumWithBox = haba + depth + height + 10;
    const symbol = getStoreSymbol(sumWithBox);

    const existingCode = findExistingCode({
      haba: haba,
      depth: depth,
      height: height,
      totalShelf: totalShelf,
      color: existingColorKey()
    });

    if (existingCode) {
      $msg.append(
        '<p class="existing-link">' +
          '<a href="' + EXISTING_URL + existingCode + '" target="_blank">' +
            '→既製品ページがございます。こちらのページよりお買い求めください。' +
          '</a>' +
        '</p>'
      );
      $('.check_price').empty();
      setCheckoutUIEnabled(false);
      $('#units').val('');
      return false;
    }

    let price = basePrice;
    price += totalShelf * 1000;
    // YHC加算（幅+奥行+高さ+段ボール）
    if (sumWithBox >= 261) {
      price += 5000;
    } else if (sumWithBox >= 241) {
      price += 3000;
    }

    const spans = document.querySelectorAll('.check_area ul li span');
    if (spans.length >= 6) {
      spans[0].textContent = haba;
      spans[1].textContent = depth;
      spans[2].textContent = height;
      spans[3].textContent = dowel;
      spans[4].textContent = colorName;
      spans[5].textContent = totalShelf;
    }

    setChoiceValues({
      haba: haba,
      depth: depth,
      height: height,
      dowel: dowel,
      colorName: colorName,
      totalShelf: totalShelf,
      symbol: symbol,
      price: price
    });

    $('.check_price').text(formatYen(price)).attr('style', '');
    $msg.append('<p class="note-submit-ok">以下の内容を確認し、買い物かごにお進みください。</p>');
    setCheckoutUIEnabled(true);
    return false;
  };

  window.checkBtn = function () { return true; };
  window.op_paneltext = function () { updateExtraPanelFieldState(); return true; };
  window.op_panelchange = function () { sanitizeExtraPanelInput(); syncDowelHole(); return true; };

  $(function () {
    loadPriceOnce();
    loadExistingOnce();
    bindResizeAfterLoad();

    if (!initialColorApplied && !$('input[name="colortype1"]:checked').length && !location.search) {
      $('#wood_br').prop('checked', true);
      initialColorApplied = true;
    }

    setBubbleBySelectedColor();
    updatePanelOptions();
    updateExtraPanelFieldState();
    updateInnerDisplays();
    updatePreviewImages();
    resizeFormSizeImages();
    resetOrderSummary();

    $(window).on('resize', resizeFormSizeImages);
    $(window).on('pageshow', function () {
      updatePanelOptions();
      updateExtraPanelFieldState();
      updateInnerDisplays();
      updatePreviewImages();
      resizeFormSizeImages();
    });

    $(document).on('change', 'input[name="colortype1"]', function () {
      if (!this.checked) return;
      setBubbleBySelectedColor();
      updateInnerDisplays();
      updatePreviewImages();
    });

    $(document).on('input', '#haba, #depth, #height', function () {
      const cleaned = onlyDigits(this.value);
      if (this.value !== cleaned) this.value = cleaned;
      updateInnerDisplayOne(this.id);
      if (this.id === 'haba') updatePanelOptions();
      updatePreviewImages();
    });

    $(document).on('blur', '#haba, #depth, #height', function () {
      validateSizeFieldForBlur(this.id);
    });

    $(document).on('change', '#panel', function () {
      syncDowelHole();
      updatePreviewImages();
    });

    $(document).on('change', '#op_panel', function () {
      updateExtraPanelFieldState();
    });

    $(document).on('input', '.form_checkbox--num', function () {
      sanitizeExtraPanelInput();
      syncDowelHole();
    });

    $('form[name="frm_detail"]').on('change input', 'input, select, textarea', function () {
      const $t = $(this);
      if ($t.is('#units, #choice1, #choice2, #choice3, #choice4, #choice5, #choice6, #choice7')) return;
      resetOrderSummary();
    });

    $(document).on('click', '#modal-cart', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('click', '.btn-cart, .cartadd', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('submit', 'form[name="frm_detail"]', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('submit', 'form[name="frm"]', function (e) {
      submitToRakutenCart(e);
    });
  });

})(jQuery);
